export const UPDATE_USER_PROFILE = `
    mutation UpdateProfile($first_name: String, $last_name: String, $phone: String, $avatar: String, $remove_avatar: Boolean) {
        updateProfile(first_name: $first_name, last_name: $last_name, phone: $phone, avatar: $avatar, remove_avatar: $remove_avatar) {
            id
            first_name
            last_name
            username
            
            phone
            avatar
        }
    }
`;

export const ADD_CUSTOM_SOCIAL_CHANNEL = `
    mutation SocialChannelAddCustom($channel_type: SocialConnectCustomEnum!, $url: String!) {
        socialChannelAddCustom(channel_type: $channel_type, url: $url) {
            id
            type
            url
            label
        }
    }
`;
